export default __webpack_public_path__ + "static/fx_button-02af1678ed2521f145c82cc18993e1ae.png";